import React, { lazy, Suspense } from 'react';

const LazyDailyDTRReport = lazy(async () => await import('./DailyDTRReport'));

const DailyDTRReport = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => (
  <Suspense fallback={null}>
    <LazyDailyDTRReport {...props} />
  </Suspense>
);

export default DailyDTRReport;
